enum ActionStatus {
  none = 'none',
  saving = 'saving',
  saved = 'saved',
  failed = 'failed',
}

export default ActionStatus;
